import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {ComplyMessageService} from '../services/comply-message.service';
import {MessageRequest} from '../model/message-request.model';
import { finalize } from 'rxjs/operators';
@Component({
    templateUrl: './edl-send-message-modal.component.html',
    styleUrls: ['./edl-send-message-modal.component.scss']
})
export class EdlModalSendMessage implements OnInit {
    @Input() target: number;
    @Input() type: number;
    @Input() typeId: string;
    @Input() typeIds: Array<string>;

    messageForm: UntypedFormGroup;
    busy: boolean;

    constructor(
        public activeModal: NgbActiveModal,
        private formBuilder: UntypedFormBuilder,
        private complyMessageService: ComplyMessageService
    ) {}

    ngOnInit() {
        this.busy = false;
        let ids:string[] = new Array<string>();
        ids = this.typeIds ? this.typeIds : [this.typeId]
        this.messageForm = this.formBuilder.group({
            Message: [null, [Validators.required]],
            Target: [this.target, [Validators.required]],
            Type: [this.type, [Validators.required]],
            TypeID: [ids, [Validators.required]]
        });
    }

    send({ value, valid }: { value: MessageRequest, valid: boolean}) {
        if (valid && !this.busy) {
            this.busy = true;
            // convert to array
            /*
            let typeID:string = value.TypeID;
            value.TypeID = new Array<string>();
            value.TypeID.push(typeID);
            */
            this.complyMessageService
                .sendMessage(value)
                .pipe(
                    finalize( () => this.busy = false)
                )
                .subscribe(() => {
                    this.activeModal.close();
                });
        }
    }

    cancel() {
        this.activeModal.dismiss();
    }
}